import React from "react";
import ProjEditImageDomUtil from '../../ProjEditImageDomUtil';
// import { Row, Col, InputGroup, DropdownButton, FormControl, Dropdown } from 'react-bootstrap';
// import { X } from 'react-bootstrap-icons';
// import { render } from "@testing-library/react";
import { useDispatch } from 'redux-react-hook';

export default function QuestionOptInputImage(props) {
    const { data, pid, onChange } = props;
    const questionIndex = props.index;
    const dispatch = useDispatch();

    function onLnkChange(key, url) {
        console.log(url)
        props.onKeyChange("lnk", url);
    }

    function handleKeyPress(e) {
        const char = e.charCode;
        // console.log(char);
        if (13 == char) { //enter
            dispatch({ type: "ON_ADD_TMP_OPTION", index: questionIndex });
        }
    }

    function render() {
        return (
            <>
                <input type="text" className="w-100 underline mb-1" value={data.na} onChange={onChange} onKeyPress={handleKeyPress} />
                <ProjEditImageDomUtil
                    onChange={onLnkChange}
                    isDisabled={false}
                    id={pid}
                    type={0} //0 : 專案, 1 : 廣告, 2 : 商品
                    // dataKey={questionIndex}
                    value={data.lnk}
                />
            </>
        );
    }

    return render();
}